/**
 * ShimmerText - Text with animated gradient shimmer effect
 *
 * Wraps text with a moving gradient background.
 * Animation speed varies by theme.
 */

"use client";

import { ReactNode } from "react";
import { useReducedMotion } from "framer-motion";
import { useLandingTheme } from "@/context/LandingThemeContext";

interface ShimmerTextProps {
  children: ReactNode;
  className?: string;
  as?: "span" | "h1" | "h2" | "h3" | "p";
}

export default function ShimmerText({
  children,
  className = "",
  as: Component = "span",
}: ShimmerTextProps) {
  const { theme } = useLandingTheme();
  const shouldReduceMotion = useReducedMotion();

  // If reduced motion, just use static gradient
  if (shouldReduceMotion) {
    return (
      <Component
        className={`bg-gradient-to-r from-pink-500 via-purple-500 to-pink-500 bg-clip-text text-transparent ${className}`}
      >
        {children}
      </Component>
    );
  }

  // Use CSS class that responds to theme
  return (
    <Component className={`shimmer-text ${className}`} data-theme={theme}>
      {children}
    </Component>
  );
}
